import { useCallback } from 'react';

import { betActions, useChipSlice, useGameStateSlice, Logger } from '@pp/core';

import { Bets } from '../../../config/bets';
import { useGameDispatch } from '../../../store/GameStore';
import { GameInstantBetsSender } from '../../../controllers/gameCommunication/senders/GameInstantBetSender';

const sender = new GameInstantBetsSender();
export const useOnBetCallbackConnected = (): ((bet: Bets) => void) => {
  const dispatch = useGameDispatch();
  const selectedChip = useChipSlice.getSelectedChip();
  const balance = useGameStateSlice.getDeductibleBalance();
  const decimals = useGameStateSlice.getCurrencyInfo()?.digitsNumber || 2;

  return useCallback(
    (bet: Bets): void => {
      if (!selectedChip) return;
      dispatch(betActions.pushBet({ bet: { betSpots: { [bet]: { value: selectedChip.value } } }, balance, decimals }));
      sender.dispatch('');
      Logger.logEvent('click', 'bet', Date.now(), 1, `${bet}`, false);
    },
    [selectedChip, dispatch, balance, decimals]
  );
};
